import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SPECIALIZED_PACKS, GALLERY_PHOTOS } from '../data/site';
export function Tier1Specialized() {
  return <section id="programs" className="w-full bg-ink py-16 sm:py-24 border-t border-ink-line" data-id="element-250" data-mp="zqy4bwuz6a7h">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-251" data-mp="uswkh9pq66uy">
        <div className="text-center mb-16" data-id="element-252" data-mp="uqacj8yx9pc7">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-orange" data-id="element-253" data-mp="ptte9ly0dule">
            Academy Pathway
          </span>
          <h2 className="mt-3 text-3xl uppercase sm:text-4xl" data-id="element-254" data-mp="ksvvp8936yjd">Tier 1: Elite Specialized Training</h2>
          <p className="mt-4 text-white/70 max-w-2xl mx-auto" data-id="element-255" data-mp="gsvj7t5jsxey">
            High-performance session-based programs designed for players looking to master elite techniques.
          </p>
        </div>

        {/* 2-Column Program Descriptions */}
        <div className="grid gap-8 md:grid-cols-2 mb-16" data-id="element-256" data-mp="267tc8rdana60">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="overflow-hidden rounded-3xl border border-ink-line bg-ink-card" data-id="element-257" data-mp="268bhgdhxoyq2">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/fc08029c-12d9-41cd-ab06-33ef4816e870.jpg" alt="Goalkeeper Training" className="w-full h-[200px] sm:h-[250px] object-cover object-[50%_10%] rounded-t-3xl" data-id="element-258" data-mp="38imf2sj1yqe0" />
            <div className="p-8" data-id="element-259" data-mp="51nqq68kwftq">
              <h3 className="font-display text-2xl uppercase text-white" data-id="element-260" data-mp="92psatpyx3yv">Goalkeeper Training Program</h3>
              <p className="mt-1 text-sm font-semibold text-brand-orange uppercase tracking-wide" data-id="element-261" data-mp="3rgqf8xgypf3o">
                Kids, Women & Men
              </p>
              <p className="mt-4 text-white/75 leading-relaxed" data-id="element-262" data-mp="8umrkkxpbip">
                Focus: GK-specific conditioning, tactical situations, and individual assessment. Build the reflexes, positioning, and confidence required to command the box.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="overflow-hidden rounded-3xl border border-ink-line bg-ink-card" data-id="element-263" data-mp="12ldsvm8wwh0w">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/77fb8120-8a37-4752-9384-0f7302e5021d.jpg" alt="Personalized Training" className="w-full h-[200px] sm:h-[250px] object-cover object-[50%_10%] rounded-t-3xl" data-id="element-264" data-mp="nomtve35h7bt" />
            <div className="p-8" data-id="element-265" data-mp="ev1g9y2q1w3z">
              <h3 className="font-display text-2xl uppercase text-white" data-id="element-266" data-mp="9xi0uuuafdag">Personalized Training Program</h3>
              <p className="mt-1 text-sm font-semibold text-brand-orange uppercase tracking-wide" data-id="element-267" data-mp="4zpyf6w0o8s0">
                Elite Soccer Condition
              </p>
              <p className="mt-4 text-white/75 leading-relaxed" data-id="element-268" data-mp="1yb6q6bhau5">
                Primary Focus: Elite Soccer Condition. Tailored 1-on-1 sessions covering coordination, ball mastery, finishing drills, and physical assessment to elevate your technical ceiling and match fitness.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Pricing Row */}
        <div className="grid gap-6 lg:grid-cols-3 lg:items-center" data-id="element-269" data-mp="2gmtgaggnmzir">
          {SPECIALIZED_PACKS.map((plan, index) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: index * 0.08
        }} className={`relative flex h-full flex-col rounded-3xl border p-7 ${plan.featured ? 'border-brand-orange/60 bg-ink-card shadow-2xl shadow-brand-red/20 lg:scale-105' : 'border-ink-line bg-ink-card'}`} data-id="element-270" data-mp="2ljads19quq8i" data-mpi={index}>
              {plan.badge && <span className="absolute -top-3 left-7 rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-271" data-mp="1a453oc7a9pev">
                  {plan.badge}
                </span>}

              <h3 className="font-display text-2xl uppercase" data-id="element-272" data-mp="3lm8ft4f208bm">{plan.name}</h3>

              <p className="mt-5 flex items-end gap-1" data-id="element-273" data-mp="3gtyopl27d27r">
                <span className="bg-gradient-to-r from-brand-orange to-brand-red bg-clip-text font-display text-5xl text-transparent" data-id="element-274" data-mp="3gsdrfnoi7567">
                  ${plan.price}
                </span>
              </p>

              <ul className="mt-6 flex-grow space-y-3 text-sm text-white/75" data-id="element-275" data-mp="3qmmehvurm5wz">
                {plan.features.map(feature => <li key={feature} className="flex gap-3" data-id="element-276" data-mp="3f271wv0i4o0">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-277" data-mp="3dr6s70rzf1n" />
                    {feature}
                  </li>)}
              </ul>

              <a href={plan.ctaHref} target="_blank" rel="noreferrer" className={`mt-8 block rounded-full px-6 py-3.5 text-center text-sm font-bold uppercase tracking-wide transition-transform hover:scale-[1.02] ${plan.featured ? 'bg-gradient-to-r from-brand-orange to-brand-red text-white shadow-lg shadow-brand-red/30' : 'border border-white/20 bg-white/5 text-white hover:bg-white/10'}`} data-id="element-278" data-mp="kq7itdcn0fn3">
                Get {plan.name}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}